import React from 'react';
import TerminationCharts from '../../../components/common/terminationChart/TerminationChart';
import CardFiltersProvider from 'components/specific/CardFilters/context/filters-context';
import { CardFiltersContext } from 'components/specific/CardFilters/context/filters-context';

export const TerminationChart = ({
  setLocalfiltersTerminated,
  totalTerminated,
  totalTerminatedMAx,
}) => {
  return (
    <CardFiltersProvider>
      <Terminated
        setLocalfiltersTerminated={setLocalfiltersTerminated}
        totalTerminated={totalTerminated}
        totalTerminatedMAx={totalTerminatedMAx}
      />
    </CardFiltersProvider>
  );
};

function Terminated({
  setLocalfiltersTerminated,
  totalTerminated,
  totalTerminatedMAx,
}) {
  const { state, dispatch, date } = React.useContext(CardFiltersContext);

  console.log('statestatestate', state);

  function formatObject(inputObj) {
    const formattedKey = inputObj.title.toUpperCase(); // Convert title to uppercase
    const selectedList = inputObj.selectedList;

    // Extract the key-value pairs from the selectedList
    const formattedList = Object.entries(selectedList).map(([name, _id]) => ({
      _id,
      name,
    }));

    // Return the object in the desired format
    return {
      [formattedKey]: formattedList,
    };
  }

  React.useEffect(() => {
    let resultForParent = {};
    state.forEach((state) => {
      resultForParent = {
        ...resultForParent,
        ...formatObject(state),
        local: true,
      };
    });

    setLocalfiltersTerminated(resultForParent, date.dateState);
  }, [
    ...state.flatMap((item) => Object.entries(item.selectedList).length),
    date.dateState,
  ]);
  return (
    <TerminationCharts
      check={date.dateState}
      state={state}
      dispatch={dispatch}
      date={date}
      title="Total Number of Terminated Contract"
      value={totalTerminated}
      maxValue={totalTerminatedMAx}
    />
  );
}
